import React from 'react';
import { colorify } from '../../../markup/commands';
import { ToolbarColors } from '../custom/ToolbarColors';
export const MToolbarColors = ({ className, editor, focus, onClick, }) => {
    return (React.createElement(ToolbarColors, { enable: true, exec: (color) => {
            colorify(editor.cm, color);
        }, className: className, focus: focus, onClick: onClick }));
};
